var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.793,
    height: 9.381,
    viewBox: "0 0 9.793 9.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.764,4.041a.52.52,0,0,0-.447-.357L6.49,3.427,5.373.812a.521.521,0,0,0-.957,0L3.3,3.427.473,3.684a.521.521,0,0,0-.3.91l2.14,1.873-.63,2.774a.52.52,0,0,0,.774.563L4.895,8.347,7.331,9.8a.521.521,0,0,0,.775-.563l-.63-2.774L9.612,4.594A.521.521,0,0,0,9.764,4.041ZM4.941,8.319",
    transform: "translate(0.004 -0.497)",
    fill: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBlue);
export default __webpack_public_path__ + "static/media/star-blue.ff30eb5fdb22d531c4132dc54d2d722b.svg";
export { ForwardRef as ReactComponent };